import React , { useEffect }    from 'react'
import { useDispatch }          from 'react-redux'
import * as viewElements        from '../../../../actions/creators/view-elements';
import Blogx                    from "./blog"
import Delete                   from "./delete"
import Edit                     from "./edit"
import { useSelector }          from 'react-redux';
import {
    useDomain
}                               from '../../../../../hooks/use';

const Blog = props => {
    const redux         = useSelector( state => ({
        isLoading       : state.getIn([ 'ui', 'provider', 'isLoading', 'Get_Blog' ]),
        blog            : state.getIn([ 'domain', 'blog', 'list' ]),
    }));
    const dispatch      = useDispatch();
    const { blog }      = useDomain({ Blog: {} });
    const blogList      = redux.blog && redux.blog.toJS() || [];

    useEffect(() => {
        blog.getBlog({});
    }, [])
    
    const onClickHandler = () => {
        dispatch(
            viewElements.createModal({
                title: "Yeni Blog Ekle 🥳",
                full : true,
                body  : props => <Blogx 
                                    { ...props } 
                                />
            })
        )
    }
    const deleteOnClickHandler = item => {
        dispatch(
            viewElements.createModal({
                title: "Blog Siliniyor 🥺",
                full : true,
                body  : props => <Delete 
                                    { ...props } 
                                    data = { item } 
                                />
            })
        )
    }
    const editOnClickHandler = item => {
        dispatch(
            viewElements.createModal({
                title: "Blog Düzenle ✍️",
                full : true,
                body  : props => <Edit 
                                    { ...props }
                                    data = { item } 
                                />
            })
        )
    }
    return (
        <div className="blog-container">
            <div className="header-title">Dashboard / Blog</div>
            <div className="blog-container-section">
                <div className="box add-blog" onClick={onClickHandler}>
                    <p>Blog Ekle</p>
                    <i className="far fa-plus-square"></i>
                </div>
                <div className="box">
                    <p>Toplam Blog Sayısı</p>
                    <span>21</span>
                </div>
                <div className="box">
                    <p>Toplam Görüntülenme</p>
                    <span>21</span>
                </div>
            </div>
            <div className="table-container">  
            <table>
                <thead>
                <tr>
                    <td>Blog Resimi</td>
                    <td>Blog Başlığı</td>
                    <td>İşlemler</td>
                </tr>
                </thead>
                <tbody>
                   {
                       blogList?.map( (item, index) => (
                        <tr key={index}>
                            <td className="blog-img">
                                <img src={item.blog_photo} />
                            </td>
                            <td>{item.blog_title || ""}</td>
                            <td>
                                <i className="fas fa-edit option" onClick={() => editOnClickHandler(item)}/>
                                <i className="fas fa-trash-alt option" onClick={() => deleteOnClickHandler(item)} />
                            </td>
                        </tr>
                       ))
                   }
                  
                </tbody>
                </table>
            </div>
        </div>
    )
}

export default Blog
